import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Typography } from 'antd';
import { Link, useHistory } from "react-router-dom";
import callme from '../../img/callme.png'

import {
  PieChartOutlined,
  QuestionCircleOutlined,
  SolutionOutlined,
  MenuOutlined,
  CloseOutlined,
  UserOutlined,
  WhatsAppOutlined,
  LogoutOutlined,
  FundProjectionScreenOutlined
} from '@ant-design/icons';
import logo from '../../img/logo.png'
import './UserLayout.scss';

import { removeCookie } from '../../utils/session';

const { Header, Content, Footer, Sider, } = Layout;
const { Title } = Typography;
const UserLayout = ({ children, profile }) => {
  const [state, setState] = useState({
    collapsed: false,
    menuCollapsed: true
  });
  let history = useHistory();

  const onCollapse = collapsed => {
    console.log(collapsed);
    setState({ ...state, collapsed });
  };
  const toggleMenu = () => {
    setState({ ...state, menuCollapsed: !menuCollapsed })
  }
  const { collapsed, menuCollapsed } = state;
  useEffect(() => {
    setState({ ...state, menuCollapsed: true })
  }, [history.location]);
  return (
    <Layout style={{ minHeight: '100vh' }} className="user-container">
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} breakpoint="lg" className="sidemenu">
        {!collapsed && <div className="logo" > <img src={logo} alt="" /></div>}
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
          <Menu.Item key="1" icon={<PieChartOutlined />}>
            <Link to="/">Dashboard</Link>
          </Menu.Item>

          <Menu.Item key="3" icon={<UserOutlined />}>
            <Link to="/profile">Profile</Link>
          </Menu.Item>
          <Menu.Item key="4" icon={<QuestionCircleOutlined />}>
            <Link to="/query">Query</Link>
          </Menu.Item>
          <Menu.Item key="5" icon={<QuestionCircleOutlined />} onClick={() => {
            toggleMenu()
          }}>
            <a href="https://www.tycl.org.in/girlsleadgirls">Visit Website</a>
          </Menu.Item>
          <Menu.Item key="6" icon={<FundProjectionScreenOutlined />} >
            <a href="https://www.tycl.org.in/girlsleadgirls/#/how-it-works">How It Works?</a>
          </Menu.Item>
          <Menu.Item key="7" icon={<LogoutOutlined />}>
            <a href="https://www.tycl.org.in/girlsleadgirls/#/" onClick={() => removeCookie("user_id")}>Logout</a>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-background" >
          <Title level={3} className="header-title">Hello {profile && profile.name}...!</Title>
          <Avatar className="avatar-logo" size="large" style={{ backgroundColor: '#87d068', float: 'right', marginTop: "12px" }} icon={<UserOutlined />} />
          <div className="logo glg-logo" >  <a href="https://www.tycl.org.in/girlsleadgirls/#/user"><img src={logo} alt="" /></a></div>
          {
            menuCollapsed ?
              <MenuOutlined onClick={() => {
                toggleMenu()
              }} className="mobileMenu" />
              : <CloseOutlined className="mobileMenu" onClick={() => {
                toggleMenu()
              }} />
          }
          <Menu className={menuCollapsed ? "mobile-menu" : "mobile-menu expand"} theme="dark" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
              <Link to="/" onClick={() => {
                toggleMenu()
              }}>Dashboard</Link>
            </Menu.Item>

            <Menu.Item key="3" icon={<UserOutlined />}>
              <Link onClick={() => {
                toggleMenu()
              }} to="/profile">Profile</Link>
            </Menu.Item>

            <Menu.Item key="4" icon={<QuestionCircleOutlined />}>
              <Link onClick={() => {
                toggleMenu()
              }} to="/query">Query</Link>
            </Menu.Item>
            <Menu.Item key="5" icon={<QuestionCircleOutlined />} onClick={() => {
              toggleMenu()
            }}>
              <a href="https://www.tycl.org.in/girlsleadgirls">Visit Website</a>
            </Menu.Item>
            <Menu.Item key="6" icon={<FundProjectionScreenOutlined />} >
              <a href="https://www.tycl.org.in/girlsleadgirls">How It Works</a>
            </Menu.Item>
            <Menu.Item key="7" onClick={() => {
              toggleMenu()
            }} icon={<LogoutOutlined />}>
              <a href="https://www.tycl.org.in/girlsleadgirls/#/" onClick={() => removeCookie("user_id")}>Logout</a>
            </Menu.Item>
          </Menu>
        </Header>
        <Content style={{ margin: '16px' }}>
          <Title level={4} style={{ marginLeft: "1px", marginBottom: "20px" }} className="mobile-header-title">Hello {profile && profile.name}...!</Title>
          {children}
        </Content>
        {/* <Footer style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: "5px" }}>For more information: <b style={{ color: "#ff5722", fontSize: "20px" }}>+919600515255</b><WhatsAppOutlined style={{ fontSize: "20px", padding: "0 7px", color: "#11e277" }} /><img src={callme} style={{
            maxWidth: "49px",
            position: "absolute",
            marginTop: "-27px",
            marginLeft: "3px"
          }} /></div>
          <div>GirlsLeadGirls ©2020, Created by TYCL</div>
        </Footer> */}
        <Footer className="guest-layout-footer" style={{ backgroundColor: 'transparent', color: "inherit" }}>
          <div style={{ marginBottom: "5px", paddingRight: "50px" }}>

            For more information: <br /><b style={{ color: "#ff5722", fontSize: "20px" }}><a href="tel:+919600515255" style={{color:"#ff5722"}}><span style={{ marginRight: "3px" }}>+91 9600515255</span></a></b><a href="https://api.whatsapp.com/send?phone=919600515255" target="_blank"><WhatsAppOutlined style={{ fontSize: "20px", padding: "0 7px", color: "#11e277" }} /></a>
            <img src={callme} />
          </div>
          <div>GirlsLeadGirls ©2020, Created by TYCL</div>
        </Footer>
      </Layout>
    </Layout>
  )
}

export default UserLayout
